import Class from '@/Class';
import type LayoutFactory from '@/Factories/LayoutFactory';

export default class LayoutFactoryTuple extends Class {

    public control: JQuery<HTMLElement>;

    public factory: LayoutFactory;

    constructor(factory: LayoutFactory, $element: JQuery) {
        super();

        this.control = $element;
        this.factory = factory;
        this.isDisposable = true;
    }
}